import * as React from 'react';
import * as styled from './styled';
import Input from 'components/Input';

/**
 * The auto check content render.
 * @return {React.ReactElement}
 * @constructor
 */
export default function AutoCheck(): React.ReactElement {
  return (
    <styled.Wrapper>
      <Input
        label="Ваш ответ"
        placeholder="Введите ответ"
      />
    </styled.Wrapper>
  );
}
